import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { ModalType } from './types';

export interface UsersAdminState {
  activeModal: ModalType | null;
}

const initialState: UsersAdminState = {
  activeModal: null,
};

const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    changeActiveModal: (state, action: PayloadAction<ModalType | null>) => {
      state.activeModal = action.payload;
      if (action.payload === null) {
        state.activeModal = null;
      }
    },
  }
});

export const selectProductsActiveModal = (state: RootState) => state.products.activeModal;

export const { changeActiveModal: changeProductsActiveModal } = productsSlice.actions;
export { productsSlice };
